import { useState } from "react";
import Button from "../Atoms/Button";
import NoteInput from "../Molecules/NoteInput";
import styles from "../../Styles/NoteForm.module.css";
import { useNotes } from "../../../Hooks/useNotes";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const NoteForm = () => {
  const [noteData, setNoteData] = useState({ title: "", text: "", id: "" });
  const [warning, setWarning] = useState("")
  const dbId = useSelector((state) => state.ui.userDBId);
  const param = useSelector((state) => state.ui.userParamName);
  const navigate = useNavigate();
  const { addNote } = useNotes();

  const noteInfoHandler = (data) => {
    setNoteData({
      title: data.title,
      text: data.text,
      id: `${data.title}_${Math.random() * 1000}`,
    });
  };

  const submitNoteHandler = (e) => {
    e.preventDefault();
    if(noteData.title !== "" && noteData.text !== ""){
      setWarning("")
      addNote(dbId, noteData);
      navigate(`/${param}`, { replace: true });
    } else {
      setWarning("Cannot Save an Empty Note :(")
    }
  };

  return (
    <form onSubmit={submitNoteHandler} className={styles.formItems}>
      {warning !== "" && <h3>{warning}</h3>}
      <NoteInput noteInfo={noteInfoHandler} />
      <div className={styles.formItems__button}>
        <Button>Submit</Button>
      </div>
    </form>
  );
};

export default NoteForm;
